import React from 'react'
import { useTranslation } from 'react-i18next'

import { Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'

import { listCreditClients } from '../../gql'
import { listProducts } from '../../../product/gql/query'

import { Select, DateTimePicker, Number } from 'components/forms'
import Divider from 'components/Divider'
import Button from 'components/Button'

const Inline = styled.div`
	display: flex;
`

const DayOrderModalForm = props => {
	const [t] = useTranslation()

	return (
		<>
			<Row>
				<Col xs>
					<Select
						label={t('credit_client_section.caption')}
						field='creditClientId'
						valueField='id'
						labelField='name'
						withVirtualBody={true}
						isSearchable
						remoteOptions={{
							query: listCreditClients
						}}
					/>
				</Col>
				<Divider height={20} />
			</Row>
			<Row>
				<Col xs>
					<Select
						label={t('category_section.strings.grid_product_list')}
						field='productId'
						valueField='id'
						labelField='name'
						withVirtualBody={true}
						isSearchable
						remoteOptions={{
							query: listProducts
						}}
					/>
				</Col>
				<Divider height={20} />
			</Row>
			<Row>
				<Col xs>
					<DateTimePicker
						label={t('common.fields.date')}
						field='date'
						placeholder={ t('common.fields.date') }
					/>
				</Col>
				<Divider height={20} />
			</Row>
			<Row>
				<Col xs>
					<Number
						field='amount'
						label={t('credit_client_section.strings.amount')}
						inline/>
				</Col>
				<Divider height={20} />
			</Row>
			<Row>
				<Col xs>
					<Number
						field='minAmount'
						label={t('credit_client_section.strings.minimum')}
						inline/>
				</Col>
				<Col xs>
					<Number
						field='maxAmount'
						label={t('credit_client_section.strings.maximum')}
						inline/>
				</Col>
				<Divider height={20} />
			</Row>
			<Row>
				<Col xs>
					<Number
						field='allottedAmount'
						label={t('credit_client_section.strings.alloted')}
						inline/>
				</Col>
				<Divider height={30} />
			</Row>
			<Row>
				<Col xs>
					<Inline>
						<Button
							type='button'
							onClick={() => props.unmount()}
							status='cancelation'
							text={t('common.buttons.abort')}/>
						<Button
							type='submit'
							status='primary'
							text={t('common.buttons.save')}/>
					</Inline>
				</Col>
			</Row>
		</>
	)
}

export default DayOrderModalForm
